import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { push } from 'react-router-redux';
import { BasicForm, InputField, TextareaField } from 'react-serial-forms';
import { doSaveRecommendedResource } from '../actions';
import t from 'tcomb-form';
import { WebsiteRefinement, WebsiteTransformer } from '../utils/tcomb-utils';

const RecommendedResourceSchema = t.struct({
  name: t.String,
  website: WebsiteRefinement,
  service_overview: t.String,
  user_comments: t.maybe(t.String)
});


const formOptions = {
  auto: 'none',
  fields: {
    name: {
      error: 'Please provide the name of the service name',
      attrs: {
        placeholder: 'Name of the resource'
      }
    },
    website: {
      error: 'Please provide a valid website address or url',
      transformer: WebsiteTransformer,
      attrs: {
        placeholder: 'Website'
      }
    },
    service_overview: {
      error: 'Please write a few words describing the service',
      type: 'textarea',
      attrs: {
        placeholder: 'What do they do?'
      }
    },
    user_comments: {
      type: 'textarea',
      attrs: {
        placeholder: 'Why do you like this resource?'
      }
    }
  }
};

class ProfileRecommend extends Component {
  state = {
    formOptions: formOptions,
    formValues: {}
  };

  constructor(props) {
    super(props);
  }

  onFormChange = formValues => {
    this.setState({formValues});
  };

  resetForm = () => {
    this.setState({ formValues: {
      name: '',
      website: '',
      service_overview: '',
      user_comments: ''
    } });
  };

  handleSubmit = e => {
    e.preventDefault();
    const value = this.refs.recommendedResourceForm.getValue();
    if(!value) {
      //
    }
    else {
      if(!value.website.startsWith('http')) {
        value.website = 'http://${value.website}';
      }

      this.props.doSaveRecommendedResource(value);
      if (typeof(window) !== "undefined") {
        window.scrollTo(0,0)
      }
      this.resetForm();
    }
  };

  componentDidMount() {
    if (typeof(window) !== "undefined") {
      window.scrollTo(0,0)
    }
  }

  render() {
    var heading = [<h1>Help us grow WorldWideWomen</h1>];

    if(this.props.temporal.recommendedResourceSaved) {
      heading = [<h1 className="saved">Saved! Recommend another resource </h1>];
    }

    return (
      <div className="profile-recommend">
        {heading}
        <p>Please recommend your favorite resources for women and girls. Help us imagine and create a powerful global network for women.<br />If you are recommending your organization or your employer organization, please <Link to="/organizations/apply">apply to be listed here</Link> instead. Thank you!</p>


        <form className="recommend-form" onSubmit={(e)=>{  e.prevenDetault(); }}>
        <t.form.Form ref="recommendedResourceForm" value={this.state.formValues} onChange={this.onFormChange} type={RecommendedResourceSchema} options={this.state.formOptions} />
        <button onClick={this.handleSubmit} className="recommend-submit submitButton button-primary" type="submit">Submit</button>&nbsp;
        </form>
      </div>
    );
  }
}


function mapStateToProps(state) {
  return state;
}

export default connect(
  mapStateToProps,
  { push, doSaveRecommendedResource }
)(ProfileRecommend);



// WEBPACK FOOTER //
// ./src/containers/ProfileRecommend.jsx